<div class="side-menu-container" *ngIf="currentReport && currentReport.LATEST">

  <div class="progress-card">
    <div class="header">
      <div class="title">Total Progress</div>
      <div class="value">{{currentReport.LATEST.COMPLETION}}<small>%</small></div>
    </div>

    <div class="progress-container mb-0 pb-0"
      [ngClass]="currentReport.LATEST.COMPLETION == 100 ? 'completed' : 'active'">
      <div class="progress w-100 progress-item">
        <div class="progress-bar" role="progressbar" [style.width]="currentReport.LATEST.COMPLETION + '%'"
          aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <!-- <button class="button secondary__button large__button w-100 mt-4 justify-content-start icon__right qb__button">
      <img class="mr-2" alt="..." src="../../../../../assets/images/qb-green-icon.png" width="25">
      Connected
    </button> -->
  </div>

  <accordion [isAnimated]="true" [closeOthers]="true">

    <accordion-group heading="Company Information" [isOpen]="stageNo > 0 && stageNo < 16">

      <accordion [isAnimated]="true" [closeOthers]="true">

        <div class="panel" style="display: block;" (click)="gotoPage('overview')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.OVERVIEW">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-overview-list-item" type="button" class="btn btn-link-no-accordion"> Overview
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.OVERVIEW"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.OVERVIEW ? null : gotoPage('location')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.LOCATION">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-location-list-item" type="button" class="btn btn-link-no-accordion"> Location
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.LOCATION"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.LOCATION ? null : gotoPage('ownership')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.OWNERSHIP">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button type="button" id="report-ownership-list-item" class="btn btn-link-no-accordion"> Ownership
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </accordion>

    </accordion-group>

    <accordion-group heading="Financials" [isDisabled]="currentReport.LATEST.MAX_STAGE < 15"
      [isOpen]="stageNo > 15 && stageNo < 30">

      <accordion [isAnimated]="true" [closeOthers]="true">

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.OWNERSHIP"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.OWNERSHIP ? null : gotoPage('income')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.INCOME">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-income-list-item" type="button" class="btn btn-link-no-accordion"> Income </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.INCOME"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.INCOME ? null : gotoPage('future-projection')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.FUTURE_PROJECTIONS">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-future-projection-list-item" type="button" class="btn btn-link-no-accordion"> Future Projections </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.FUTURE_PROJECTIONS"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.FUTURE_PROJECTIONS ? null : gotoPage('rent/rent-details')"
          *ngIf="reportService.showRentAdjustments()">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.RENT_DETAILS">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-rent-list-item" type="button" class="btn btn-link-no-accordion"> Rent </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="(reportService.showRentAdjustments() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.RENT_DETAILS) || (!reportService.showRentAdjustments() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.FUTURE_PROJECTIONS)"
          (click)="(reportService.showRentAdjustments() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.RENT_DETAILS) || (!reportService.showRentAdjustments() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.FUTURE_PROJECTIONS) ? null : gotoPage('salary/manager-salary')"
          *ngIf="reportService.showOwnershipSalary() == 1">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.MANAGER_SALARY">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button type="button" id="report-owners-salary-list-item" class="btn btn-link-no-accordion">
                    Owner’s Salary
                    <!-- General Manager Salary -->
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.RENT_DETAILS"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.RENT_DETAILS ? null : gotoPage('salary/replacement-salary')"
          *ngIf="reportService.showOwnershipSalary() == 2">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.REPLACEMENT_SALARY">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button type="button" id="report-owners-replacement-salary-list-item"
                    class="btn btn-link-no-accordion">
                    Owner’s Salary
                    <!-- Fair Market Replacement Salary -->
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.MANAGER_SALARY && currentReport.LATEST.MAX_STAGE < pageNumberEnum.REPLACEMENT_SALARY"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.MANAGER_SALARY && currentReport.LATEST.MAX_STAGE < pageNumberEnum.REPLACEMENT_SALARY ? null : gotoPage('adjustments')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.ADJUSTMENTS">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-adjustments-list-item" type="button" class="btn btn-link-no-accordion"> Adjustments
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ADJUSTMENTS"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ADJUSTMENTS ? null : gotoPage('weighting/weighting-table')"
          *ngIf="reportService.showWeighting()">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.WEIGHTING_TABLE">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-weighting-list-item" type="button" class="btn btn-link-no-accordion"> Summary
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ADJUSTMENTS"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ADJUSTMENTS ? null : gotoPage('projections/projection-table')"
          *ngIf="!reportService.showWeighting()">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.PROJECTION_TABLE">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-projections-list-item" type="button" class="btn btn-link-no-accordion"> Projections
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="(reportService.showWeighting() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.WEIGHTING_TABLE) || (!reportService.showWeighting() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.PROJECTION_TABLE)"
          (click)="(reportService.showWeighting() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.WEIGHTING_TABLE) || (!reportService.showWeighting() && currentReport.LATEST.MAX_STAGE < pageNumberEnum.PROJECTION_TABLE) ? null : gotoPage('assets-liabilities')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.ASSETS_LIABILITIES">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-assets-liabilities-list-item" type="button" class="btn btn-link-no-accordion">
                    Assets / Liabilities </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </accordion>

    </accordion-group>

    <accordion-group heading="Risk" [isDisabled]="currentReport.LATEST.MAX_STAGE < 29"
      [isOpen]="stageNo > 29 && stageNo < 37">
      <accordion [isAnimated]="true" [closeOthers]="true">

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ASSETS_LIABILITIES"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.ASSETS_LIABILITIES ? null : gotoPage('risk/diversification')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.DIVERSIFICATION">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-diversification-list-item" type="button" class="btn btn-link-no-accordion">
                    Diversification / Сoncentration </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.DIVERSIFICATION"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.DIVERSIFICATION ? null : gotoPage('risk/personal-goodwill')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.PERSONAL_GOODWILL">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-personal-goodwill-list-item" type="button" class="btn btn-link-no-accordion">
                    Personal Goodwill </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.PERSONAL_GOODWILL"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.PERSONAL_GOODWILL ? null : gotoPage('risk/barriers-entry')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.BARRIERS_ENTRY">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-barriers-to-entry-list-item" type="button" class="btn btn-link-no-accordion">
                    Barriers to Entry </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.BARRIERS_ENTRY"
          (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.BARRIERS_ENTRY ? null : gotoPage('risk/recurring-revenue')">
          <div class="panel card panel-default">
            <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.RECURRING_REVENUE">
              <div class="panel-title">
                <div role="button" class="accordion-toggle" aria-expanded="false">
                  <button id="report-recurring-revenue-list-item" type="button" class="btn btn-link-no-accordion">
                    Recurring Revenue </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </accordion>
    </accordion-group>

    <div class="panel border-bottom" style="display: block;" [class.disabled__panel]="currentReport.LATEST.MAX_STAGE < pageNumberEnum.RECURRING_REVENUE"
      (click)="currentReport.LATEST.MAX_STAGE < pageNumberEnum.RECURRING_REVENUE ? null : gotoPage('conclusion')">
      <div class="panel card panel-default">
        <div role="tab" class="panel-heading card-header panel-enabled" [class.active]="stageNo == pageNumberEnum.CONCLUSION">
          <div class="panel-title">
            <div role="button" class="accordion-toggle" aria-expanded="false">
              <button id="report-conclusion-list-item" type="button" class="btn btn-link-no-accordion"> Final Value
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </accordion>

</div>

<ng-container *ngIf="currentReport">
  <div class="light__blue__box icon mt-4 d-flex" *ngIf="currentReport.STATE != reportStateEnum.CREATED && currentReport.STATE != reportStateEnum.NON_BILLABLE">
    <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
    <div class="ml-3 font-size-14" *ngIf="currentReport.STATE == reportStateEnum.UNLOCKED">
      The ability to edit this report will expire in {{reportService.getReportExpireRemainingDay()}} {{reportService.getReportExpireRemainingDay() > 1 ? 'days' : 'day'}} on {{currentReport.UNLOCKED_EXP}}
    </div>
    <div class="ml-3 font-size-14" *ngIf="currentReport.STATE == reportStateEnum.LOCKED">
      <span *ngIf="currentReport?.CREATED_BY?.ID == userService.getUserId()">The report is locked. Please unlock the report for editing.</span>
      <span *ngIf="currentReport?.CREATED_BY?.ID != userService.getUserId()">To edit, have the report owner unlock the report.</span>
    </div>
  </div>
</ng-container>

<div class="promo__block" *ngIf="stageNo == pageNumberEnum.CONCLUSION && userService.isBrokerUser">
  <div class="promo__header">Promo Code</div>
  <input type="text" class="input input__blue input__large" [(ngModel)]="PROMO_CODE"
         name="txtPromo" maxlength="50" id="txtPromo" placeholder="Promo Code">
  <div class="font-size-14 font-weight-bold color-secondary-gray" *ngIf="!userService.isPremiumUser">Enter a Promo Code to avoid paying $300 to unlock the report.</div>
  <div class="font-size-14 font-weight-bold color--green" *ngIf="userService.isPremiumUser">Promo Code has been accepted, your report has been unlocked.</div>

  <button type="button" class="button large__button primary__button w-100 mt-3"
          [disabled]="!PROMO_CODE" (click)="applyPromoCode()">Apply</button>

</div>

<div class="resources__block" *ngIf="false">
  <div class="resources__header">Resources</div>

  <div class="row resources__items my-4">
    <div class="col-md-4">
      <img src="../../../../../assets/images/profilePhoto.jpg" alt="...">
    </div>
    <div class="col-md-8 pl-0">
      <div class="title two__line__ellipsis">How to Mitigate Risk of Customer Concentration How to Mitigate Risk of Customer Concentration</div>
      <div class="details two__line__ellipsis">To first understand how to mitigate the risk of customer concentratio To first understand how to mitigate the risk of customer concentratio</div>
    </div>
  </div>

</div>
